import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Header from '../header/Header';
import Icon from '../../../components/icon/Icon';
import { isMobileScreenSize } from '../../../core/utils/isMobileScreenSize';
import HeaderMobileScreen from '../header/header-mobile-screen/HeaderMobileScreen';
import HeaderMobileMenu from '../header/header-mobile-menu/HeaderMobileMenu';

import './InfoPage.scss';

interface Props {
  title?: string;
  subtitle?: string;
  buttonRoute?: string;
  buttonText?: string;
  img: string;
}

const InfoPage: React.FC<Props> = ({ title, subtitle, buttonRoute, buttonText, img }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isMobileScreen = isMobileScreenSize();

  const renderInfoContent = () => {
    return (
      <div className={`info-page ${isMobileScreen ? 'info-page--mobile' : ''}`}>
        <img src={img} alt="logo" className="info-page__img" />
        {title && <p className="info-page__title">{title}</p>}
        {subtitle && <p className="info-page__subtitle">{subtitle}</p>}
        {buttonText && (
          <div className="info-page__inner">
            <Link to={buttonRoute ?? ''} className={`button button--red ${isMobileScreen ? 'button--block' : ''}`}>
              {buttonText}
              <Icon className="login__button-icon" icon="arrowRight" size="extra-small" />
            </Link>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {!isMobileScreen ? <Header /> : <HeaderMobileScreen isMenuOpen={isMobileMenuOpen} handleMenu={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />}
      {isMobileMenuOpen && (
        <div className="info-page__menu">
          <HeaderMobileMenu closeMenu={() => setIsMobileMenuOpen(false)} />
        </div>
      )}
      {renderInfoContent()}
    </>
  );
};

export default InfoPage;
